import { LocaleProvider } from '@op/opds.opux';
import './App.css';
import React, { useEffect } from 'react';
import { MessageProvider, useMessageGetter } from '@messageformat/react';
import InsuranceOffer from './components/InsuranceOffer';
import ContextProviders from './context';
import messages from './messages/MessageData';
import { analytics } from './utils';
import { DEFAULT_LOCALE } from './constants/common';
import { useInsuranceOffer } from './hooks';

import {
  Route,
  Routes,
  useNavigate,
  useLocation,
  BrowserRouter as Router,
} from 'react-router';


const App = ({ locale = DEFAULT_LOCALE, ...props }) => {
  const getMessage = messages[locale];
  const currentLang = getMessage ? locale : DEFAULT_LOCALE;

  return (
    <LocaleProvider locale={currentLang}>
      <MessageProvider
        locale={DEFAULT_LOCALE}
        messages={messages[DEFAULT_LOCALE]}
        debug={debugMissingMessages}
      >
        <MessageProvider
          locale={currentLang}
          messages={getMessage || messages[DEFAULT_LOCALE]}
          debug={debugMissingMessages}
        >
          <ContextProviders>
            <MakeRouter {...props} locale={currentLang} />
          </ContextProviders>
        </MessageProvider>
      </MessageProvider>
    </LocaleProvider>
  );
};

const Initializer = (props) => {
  const navigate = useNavigate();
  const { visitorAction } = analytics();
  window.onbeforeunload = function () {
    window.scrollTo(0, 0);
  };
  const { locale } = props;
  useEffect(() => {
    visitorAction({
      phase: '1. vakuutettavat kohteet',
      phaseCategory: 'start',
      pageName: 'vakuutettavat-kohteet',
      error: null,
      language: locale,
      products: '',
    });
  }, [locale, visitorAction]);
  return <InsuranceOffer {...props} navigate={navigate} />;
};

const ThankyouPage = ({ locale }) => {
  const location = useLocation();
  const { visitorAction } = analytics();
  const { state } = useInsuranceOffer();
  const products = location.state?.products;
  window.onbeforeunload = function () {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    const { showContactInfo } = state;
    if (!showContactInfo && products) {
      visitorAction({
        phase: '4. kiitossivu',
        phaseCategory: 'completed',
        pageName: 'kiitossivu',
        error: null,
        language: locale,
        products: products || '',
      });
    }
  }, [locale, visitorAction, products, state, location.key]);

  return <React.Fragment />;
};

const getBaseName = (getMessage) =>
  process.env.NODE_ENV === 'development' ? '' : getMessage('url.baseName');

const getPathName = (baseName, path, locale) =>
  locale ? `/${locale}${baseName}${path}` : `${baseName}${path}`;

const MakeRouter = (props) => {
  const { locale } = props;
  const getMessage = useMessageGetter();
  const initializer = '/';
  const thankyoupage = getMessage('url.thankyoupage');
  const baseName = getBaseName(getMessage);

  return (
    <Router>
      <Routes>
        <Route
          path={getPathName(baseName, initializer)}
          element={<Initializer {...props} />}
        />
        <Route
          path={getPathName(baseName, initializer, locale)}
          element={<Initializer {...props} />}
        />
        <Route
          path={getPathName(baseName, thankyoupage)}
          element={<ThankyouPage {...props} />}
        />
        <Route
          path={getPathName(baseName, thankyoupage, locale)}
          element={<ThankyouPage {...props} />}
        />
      </Routes>
    </Router>
  );
};

/* istanbul ignore next */
const debugMissingMessages = (message, id) => {
  // Render the key that was not found from message jsons
  return () => id;
};

App.displayName = 'App';
export default App;
